import Constant from '@/common/constant/Constant';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import { cloneDeep } from 'lodash';
import { atom } from 'recoil';

let helpdeskTicketListDefaultViewStructure = cloneDeep(Constant.DEFAULT_VIEW_STRUCTURE);
let viewStructureOptions = helpdeskTicketListDefaultViewStructure.options;
viewStructureOptions['sort'] = Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.UPDATED_AT;
helpdeskTicketListDefaultViewStructure.options = viewStructureOptions;

/**
 * helpdeskTicketListViewStructureAtom
 * default view structure in helpdesk list ticket
 */
export const helpdeskTicketListViewStructureAtom = atom({
    key: 'helpdeskTicketListViewStructureAtom',
    default: helpdeskTicketListDefaultViewStructure
});

/**
 * helpdeskTicketListDefaultSelectedOptionAtom
 * default selected option in helpdesk list ticket
 */
export const helpdeskTicketListDefaultSelectedOptionAtom = atom({
    key: 'helpdeskTicketListDefaultSelectedOptionAtom',
    default: []
});


/**
 * helpdeskTicketListDrillDownDataAtom
 * drilldown data in helpdesk list ticket
 */
export const helpdeskTicketListDrillDownDataAtom = atom({
    key: 'helpdeskTicketListDrillDownDataAtom',
    default: []
});


/**
 * helpdeskTicketListIsLoadingDrillDownDataAtom
 * loading get dilldown data in helpdesk list ticket
 */
export const helpdeskTicketListIsLoadingDrillDownDataAtom = atom({
    key: 'helpdeskTicketListIsLoadingDrillDownDataAtom',
    default: false
});


/**
 * helpdeskTicketListDefaultDrillDownDataAtom
 */
export const helpdeskTicketListDefaultDrillDownDataAtom = atom({
    key: 'helpdeskTicketListDefaultDrillDownDataAtom',
    default: []
});

export const helpdeskTicketListVisibilityAtom = atom({
    key: 'helpdeskTicketListVisibilityAtom',
    default: Constant.VISIBILITY_SETTING_TYPE.PRIVATE
});

export const listOptionViewVisibilityForKnowledgeAtom = atom({
    key: 'listOptionViewVisibilityForKnowledgeAtom',
    default: []
});

export const visibilityForKnowledgeAtom = atom({
    key: 'visibilityForKnowledgeAtom',
    default: Constant.VISIBILITY_SETTING_TYPE.PRIVATE
});

export const isShowVisibilityKnowledgeAtom = atom({
    key: 'isShowVisibilityKnowledgeAtom',
    default: true
});

/**
 * helpdeskTicketLastUserActionAtom
 * last user action in helpdesk list ticket
 */
export const helpdeskTicketLastUserActionAtom = atom({
    key: 'helpdeskTicketLastUserActionAtom',
    default: LogKibanaConstant.SEARCH_ACTION.VIEW_CHANGE
});

export const helpdeskTicketSearchTagSuggestAtom = atom({
    key: 'helpdeskTicketSearchTagSuggestAtom',
    default: []
});

export const helpdeskTicketContainAnyAtom = atom({
    key: 'helpdeskTicketContainAnyAtom',
    default: []
});

export const helpdeskTicketNotIncludeAtom = atom({
    key: 'helpdeskTicketNotIncludeAtom',
    default: []
});

export const knowledgeSearchTagSuggestAtom = atom({
    key: 'knowledgeSearchTagSuggestAtom',
    default: []
});

export const publicKnowledgeSearchTagSuggestAtom = atom({
    key: 'publicKnowledgeSearchTagSuggestAtom',
    default: []
});

export const publicKnowledgeHitNumberTicketAtom = atom({
    key: 'publicKnowledgeHitNumberTicketAtom',
    default: 0
});

export const drilldownDataSelectedForLog = atom({
    key: 'drilldownDataSelectedForLog',
    default: []
});

export const triggerReLoadHelpdeskTicketDetailAtom = atom({
    key: 'triggerReLoadHelpdeskTicketDetailAtom',
    default: ''
});
